import { render, staticRenderFns } from "./KanbanStage.vue?vue&type=template&id=168846c8&"
import script from "./KanbanStage.vue?vue&type=script&lang=js&"
export * from "./KanbanStage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports